import React, { useEffect, useState } from "react";
import {usdtContract, safeContract} from "./ConAddsAndABIs"
import TheLoyalHodlersVault from "./TheLoyalHodlersVault";
import TheInitialLiquidity from "./TheInitialLiquidity";
import TheSafePresalePhase2LadderVault from "./theSafePresalePhase2LadderVault";
import TheAirdropVault from "./TheAirdropVault";
import TheDipLadderVault from "./TheDipLadderVault";
import TheSafetyLadderVault from "./TheSafetyLadderVault";



function Home(){
    const [walletAddress, setWalletAddress] = useState("");    
    const [usdtBalance, setUsdtBalance] = useState('');
    const [safeBalance, setSafeBalance] = useState('');

    useEffect(() => {  

        const getWalletAddress = async () => {
            const accounts = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            const account = accounts[0]
            const accountF = account.toString()
            setWalletAddress(accountF);
        }

        getWalletAddress()
            .catch(console.error)

// - - - - - - - - - - 
const geBalances = async () => {
    const a = await usdtContract.balanceOf(walletAddress) / (10**6);
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    const c = await safeContract.balanceOf(walletAddress) / (10**18);
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    setUsdtBalance(b)
    setSafeBalance(d)
  }  

  geBalances()
  .catch(console.error)          


    })


    return(
        <div>

            <div className="row">
                <div className="side">                    
                  <h2>My Balances</h2><br/>
                  <h3>SAFE: {safeBalance}</h3>
                  <h3>USDC: {usdtBalance}</h3><br/>





                </div>
                
                <div className="main">
                    <TheInitialLiquidity />

                    <TheSafePresalePhase2LadderVault />

                    <TheLoyalHodlersVault />

                    <TheAirdropVault />
                    
                    <TheSafetyLadderVault />

                    <TheDipLadderVault />









                    <h5>Social Media Accounts:</h5>
                    <a href="https://x.com/arthiehan" style={{"fontSize":"12px"}}><b>Twitter</b></a><br/>
                    <a href="https://t.me/+PjQmn-PnLmdjYjc1" style={{"fontSize":"12px"}}><b>Telegram</b></a><br/>
                    <a href="https://www.youtube.com/@SafeyieldCryptoStrategist" style={{"fontSize":"12px"}}><b>Youtube</b></a>
                    <br />

                    </div>
                </div>


        </div>
        
    )
}

export default Home;